import { BankAccount } from '__generated__/GQL';
import { BankAccountIllustrationName } from 'components/BankAccountIcon';

import { DEFAULT_ILLUSTRATION_NAME } from './constants';
import locales from './locales';

export const MAIN_ACCOUNT_TYPE = 'MAIN';

export const isMainBankAccountType = (type: string) => {
  return type === MAIN_ACCOUNT_TYPE;
};
export type BalanceKey = 'currentBalance' | 'nextBalance';

export const getTotalBalance = ({
  bankAccounts,
  key,
}: {
  bankAccounts: Pick<BankAccount, BalanceKey>[];
  key: BalanceKey;
}) => {
  return bankAccounts.reduce((acc, bankAccount) => acc + bankAccount[key], 0);
};

export const getBankAccountDisplayNameWithSpecificLocale = <
  TBankAccount extends Pick<BankAccount, 'type' | 'name'>,
>({
  bankAccount,
  locale,
}: {
  bankAccount: TBankAccount;
  locale: string;
}) => {
  return isMainBankAccountType(bankAccount.type) ? locale : bankAccount.name;
};

export const getBankAccountDisplayName = <
  TBankAccount extends Pick<BankAccount, 'type' | 'name'>,
>(
  bankAccount: TBankAccount,
) =>
  getBankAccountDisplayNameWithSpecificLocale({
    bankAccount,
    locale: locales.mainAccount,
  });

export const parseBankAccountIllustrationName = (
  illustrationName: string | null,
) =>
  (illustrationName ||
    DEFAULT_ILLUSTRATION_NAME) as BankAccountIllustrationName;
